import TeoHockHai from "../Assets/TeoHockHai.png";
import * as React from "react";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function Card() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div className="card">
      <div>
        <img
          className="card-img-style"
          src={TeoHockHai}
          alt="judge picture"
        ></img>
      </div>

      <div className="card-text-style">
        <h2 className="card-name-style">Teo Hock Hai</h2>
        <p className="card-sub-name-style">
          Provost's Chair Professor
          <br />
          Director (Humanities & Social Sciences Research), NUS Office of the
          Deputy President
        </p>
        <br />

        <button className="readmore-button" onClick={handleOpen}>
          Read More
        </button>
        <Modal
          className="close-button"
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="popup-style">
            <CloseIcon className="close-icon" onClick={handleClose} />
            <h2>Teo Hock Hai</h2>
            <h3>
              Provost's Chair Professor
              <br />
              Director (Humanities & Social Sciences Research), NUS Office of
              the Deputy President
            </h3>

            <br />
            <p>
              Hock-Hai Teo is Provost's Chair Professor of Information Systems.
              He served as the Head of the Department of Information Systems at
              the School of Computing, National University of Singapore from
              August 2008 to June 2015 and as Vice-Dean, Corporate
              Communications from August 2007 to August 2008. His current
              research interests focus mainly on Health Informatics, open
              innovation, and IT artifacts that are geared towards improving
              individual decision-making, health outcomes and educational
              outcomes. Dr. Teo has published broadly in journals such as the
              ACM Transactions on Computer-Human Interactions, MIS Quarterly,
              Journal of Management Information Systems, Information Systems
              Research, IEEE Transactions on Engineering Management,
              International Journal of Human-Computer Studies, and Information
              and Management and has presented at numerous international
              conferences, including the International Conference on Information
              Systems. He is currently serving or has served on the editorial
              boards of Data Base for Advances in Information Systems, European
              Journal of Information Systems, International Journal of
              Electronic Commerce, Information Systems Research, IEEE
              Transactions on Engineering Management and MIS Quarterly. He has
              won numerous best paper award at conferences and was also the
              winner of the MIS Quarterly Reviewer of the Year (2004) award.
            </p>
          </div>
        </Modal>
      </div>

      <div></div>
    </div>
  );
}

export default Card;
